/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Copy_Link_ButtonInputs */

const en_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Link`)
};

const fr_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le lien`)
};

const de_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

const it_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia collegamento`)
};

const ru_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать ссылку`)
};

const es_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar enlace`)
};

const zh_cn2_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制链接`)
};

const ja_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピー`)
};

const hi_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक की प्रतिलिपि करें`)
};

const pt_pt2_team_share_copy_link_button = /** @type {(inputs: Team_Share_Copy_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar link`)
};

/**
* | output |
* | --- |
* | "Copy Link" |
*
* @param {Team_Share_Copy_Link_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_copy_link_button = /** @type {((inputs?: Team_Share_Copy_Link_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Copy_Link_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_copy_link_button(inputs)
	if (locale === "de") return de_team_share_copy_link_button(inputs)
	if (locale === "it") return it_team_share_copy_link_button(inputs)
	if (locale === "ru") return ru_team_share_copy_link_button(inputs)
	if (locale === "es") return es_team_share_copy_link_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_copy_link_button(inputs)
	if (locale === "ja") return ja_team_share_copy_link_button(inputs)
	if (locale === "hi") return hi_team_share_copy_link_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_copy_link_button(inputs)
	return en_team_share_copy_link_button(inputs)
});